export enum AssetType {
  Audio = 'audio',
  Image = 'image',
  Raw = 'raw',
  Video = 'video',
}
